<template>
  <div>
    <div
    v-if="$attrs.value.tiktok_product_id"
    >
      <h4>เชื่อมต่อแล้วกับ : {{ $attrs.value.salechannel }}</h4>
      <tiktok-product-info
      :value="$attrs.value"
      :parentData="parentData"
      class="mt-4"
      ></tiktok-product-info>
    </div>
    <div v-else-if="tiktokList">
      <v-row>
        <v-col>
          <v-select
            v-model="$attrs.value.tiktok_salechannel_id"
            :items="tiktokList"
            label="เลือกช่องทาง Tiktok"
            item-text="name"
            item-value="id"
            outlined
            dense
            :rules="[validators.required]"
            hide-details="auto"
            clearable
          >
          </v-select>
        </v-col>
      </v-row>
      <tiktok-product-info
      :value="$attrs.value"
      :parentData="parentData"
      class="mt-4"
      v-if="$attrs.value.tiktok_salechannel_id"
      ></tiktok-product-info>
    </div>
    <div v-else>
      <div>
        <label class="text-h6 error--text">**ข้อจำกัดในการเชื่อมต่อกับทาง Tiktok**</label>
        <p>- สินค้าบางประเภทจะไม่สามารถสร้างผ่านช่องทางนี้ได้ ให้สร้างผ่านทาง Tiktok โดยตรง และให้ใส่ sku ในระบบนี้ ให้ตรงกันกับ seller_sku ใน Tiktok ระบบจะทำการเชื่อมให้โดยอัตโนมัติ ในกรณีที่มีออเดอร์เข้ามา</p>
        <p>- สินค้าหลายตัวเลือก (Variable/Variation) จะต้องเลือกตัวเลือกแยกตางหากตามที่ Tiktok บังคับ</p>
      </div>
      <v-btn
      color="black"
      class="white--text mt-2"
      @click="getTiktokSaleChannels"
      :disabled="$store.getters['app/GET_APP_MODE'] == 'read'"
      :loading="loading"
      >กดที่นี่เพื่อเลือกช่องทางการขาย Tiktok</v-btn>
    </div>
  </div>
</template>
<script>
import errorParser from '@/plugins/errorparser'
import TiktokProductInfo from './TiktokProductInfo.vue'
import { asyncGet } from '@/helpers/asyncAxios'
import {
  integerValidator,
  lengthValidator,
  maxLengthValidator,
  maxValueValidator,
  minLengthValidator,
  minValueValidator,
  numberValidator,
  required,
} from '@core/utils/validation'
export default {
  props: ['parentData'],
  data() {
    return {
      loading: false,
      tiktokList: null,
      validators: {
        required,
        lengthValidator,
        minLengthValidator,
        maxLengthValidator,
        integerValidator,
        numberValidator,
        minValueValidator,
        maxValueValidator,
      },
    }
  },
  methods: {
    async getTiktokSaleChannels() {
      try {
        this.loading = true

        const response = await asyncGet('/product/tiktokList')

        this.tiktokList = response
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', errorParser(error))
      }

      this.loading = false
    },
  },
  components: {
    TiktokProductInfo,
  },
}
</script>
